<template>
  <vs-row vs-justify="center">
        <vs-col
          style="padding: 0; padding-right: 15px"
          type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="6"
        >
          <vs-card class="cardx" style="display: inline">
            <div slot="header">
              <h3 align="center">Medicine Storage Room 1</h3>
            </div>
            <vs-row>
              <vs-col vs-w="6" style="padding: 0">
                <vs-card
                  style="border-radius: 15px; margin-bottom: 0; height: 215px"
                >
                  <vs-row id="center">
                    <vs-list-header
                      :title="gw1n"
                      style="font-size: 15px"
                      color="dark"
                    ></vs-list-header>
                  </vs-row>
                  <vs-row>
                    <img
                      src="../../../../../assets/images/gateway.png"
                      width="100"
                      height="100"
                    />
                    <vs-col vs-w="6" style="padding: 0; padding-left: 15px">
                      <h6 class="font-weight-bold">MAC Address</h6>
                      <h6 class="mt-1">AC233FC0BA77</h6>
                      <h6 class="mt-2 font-weight-bold">
                        Status
                        <vs-icon
                          v-if="st1 === 'Active'"
                          align="center"
                          icon="fiber_manual_record"
                          color="primary"
                        >
                        </vs-icon>
                        <vs-icon
                          v-if="st1 === 'Inactive'"
                          align="center"
                          icon="fiber_manual_record"
                          color="red"
                        >
                        </vs-icon>
                      </h6>
                      <h6 class="mt-2 font-weight-bold">Last Seen</h6>
                      <p class="mt-1">{{ lt1 }}</p>
                    </vs-col>
                  </vs-row>
                </vs-card>
              </vs-col>
              <vs-col vs-w="6" style="padding: 0; padding-left: 15px">
                <vs-card style="border-radius: 15px; height: 215px">
                  <vs-row id="center">
                    <vs-list-header
                      title="Asset"
                      style="font-size: 15px"
                      color="dark"
                    ></vs-list-header>
                  </vs-row>
                  <vs-row>
                    <img
                      src="../../../../../assets/images/asset.png"
                      width="80"
                      height="100"
                    />
                    <vs-col vs-w="6" style="padding: 0">
                      <h6 class="font-weight-bold">Actual Found: 5</h6>
                      <h6 class="mt-2 font-weight-bold">Today Found: {{staf1}}</h6>
                    </vs-col>
                  </vs-row>
                </vs-card>
              </vs-col>
            </vs-row>
            <vs-row
              vs-align="flex-end"
              vs-type="flex"
              vs-justify="space-between"
              vs-w="12"
            >
              <vs-col
                style="padding: 0"
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="12"
                vs-sm="12"
                vs-xs="12"
              >
                <vs-card style="border-radius: 15px; padding-left: 5">
                  <vs-table :data="tableTempDB" max-items="5" pagination>
                    <template slot="header">
                      <vs-list-header
                        title="Asset Tags"
                        style="font-size: 18px"
                        color="dark"
                      ></vs-list-header>
                    </template>
                    <template slot="thead">
                      <vs-th sortKey="name">
                        Name <vs-icon icon="swap_vert" size="small"></vs-icon>
                      </vs-th>
                      <vs-th> Mac Address </vs-th>
                      <vs-th> Distance </vs-th>
                      <vs-th> rssi </vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td :data="data[indextr].name">
                          <vs-button
                            id="noWrap"
                            @click="viewSensor(tr)"
                            icon="signal_cellular_alt"
                            type="flat"
                            >{{ data[indextr].name }}</vs-button
                          >
                        </vs-td>

                        <vs-td :data="data[indextr].mac">
                          {{ data[indextr].mac }}
                        </vs-td>
                        <vs-td :data="data[indextr].dis">
                          {{ data[indextr].dis }}
                        </vs-td>

                        <vs-td :data="data[indextr].rssi">
                          {{ data[indextr].rssi }}
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </vs-card>
              </vs-col>
            </vs-row>
          </vs-card>
        </vs-col>
        <vs-col
          style="padding: 0; padding-right: 15px"
          type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="6"
        >
          <vs-card class="cardx" style="display: inline">
            <div slot="header">
              <h3 align="center">Medicine Storage Room 2</h3>
            </div>
            <vs-row>
              <vs-col vs-w="6" style="padding: 0">
                <vs-card
                  style="border-radius: 15px; margin-bottom: 0; height: 215px"
                >
                  <vs-row id="center">
                    <vs-list-header
                      :title="gw2n"
                      style="font-size: 15px"
                      color="dark"
                    ></vs-list-header>
                  </vs-row>
                  <vs-row>
                    <img
                      src="../../../../../assets/images/gateway.png"
                      width="100"
                      height="100"
                    />
                    <vs-col vs-w="6" style="padding: 0; padding-left: 15px">
                      <h6 class="font-weight-bold">MAC Address</h6>
                      <h6 class="mt-1">AC233FC064A9</h6>
                      <h6 class="mt-2 font-weight-bold">
                        Status
                        <vs-icon
                          v-if="st1 === 'Active'"
                          align="center"
                          icon="fiber_manual_record"
                          color="primary"
                        >
                        </vs-icon>
                        <vs-icon
                          v-if="st1 === 'Inactive'"
                          align="center"
                          icon="fiber_manual_record"
                          color="red"
                        >
                        </vs-icon>
                      </h6>
                      <h6 class="mt-2 font-weight-bold">Last Seen</h6>
                      <p class="mt-1">{{ lt1 }}</p>
                    </vs-col>
                  </vs-row>
                </vs-card>
              </vs-col>
              <vs-col vs-w="6" style="padding: 0; padding-left: 15px">
                <vs-card style="border-radius: 15px; height: 215px">
                  <vs-row id="center">
                    <vs-list-header
                      title="Asset"
                      style="font-size: 15px"
                      color="dark"
                    ></vs-list-header>
                  </vs-row>
                  <vs-row>
                    <img
                      src="../../../../../assets/images/asset.png"
                      width="80"
                      height="100"
                    />
                    <vs-col vs-w="6" style="padding: 0">
                      <h6 class="font-weight-bold">Actual Found: 5</h6>
                      <h6 class="mt-2 font-weight-bold">Today Found: {{staf2}}</h6>
                    </vs-col>
                  </vs-row>
                </vs-card>
              </vs-col>
            </vs-row>
            <vs-row
              vs-align="flex-end"
              vs-type="flex"
              vs-justify="space-between"
              vs-w="12"
            >
              <vs-col
                style="padding: 0"
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="12"
                vs-sm="12"
                vs-xs="12"
              >
                <vs-card style="border-radius: 15px; padding-left: 5">
                  <vs-table :data="tableTempBF" max-items="5" pagination>
                    <template slot="header">
                      <vs-list-header
                        title="Asset Tags"
                        style="font-size: 18px"
                        color="dark"
                      ></vs-list-header>
                    </template>
                    <template slot="thead">
                      <vs-th sortKey="name">
                        Name <vs-icon icon="swap_vert" size="small"></vs-icon>
                      </vs-th>
                      <vs-th> Mac Address </vs-th>
                      <vs-th> Distance </vs-th>
                      <vs-th> rssi </vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td :data="data[indextr].name">
                          <vs-button
                            id="noWrap"
                            @click="viewSensor(tr)"
                            icon="signal_cellular_alt"
                            type="flat"
                            >{{ data[indextr].name }}</vs-button
                          >
                        </vs-td>

                        <vs-td :data="data[indextr].mac">
                          {{ data[indextr].mac }}
                        </vs-td>
                        <vs-td :data="data[indextr].dis">
                          {{ data[indextr].dis }}
                        </vs-td>

                        <vs-td :data="data[indextr].rssi">
                          {{ data[indextr].rssi }}
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </vs-card>
              </vs-col>
            </vs-row>
          </vs-card>
        </vs-col>
      </vs-row>
</template>
<script>

import { ToggleButton } from "vue-js-toggle-button";
import moment from "moment";
export default {
  components: {
    
    ToggleButton,
    
    
  },
  data: () => ({
    data: [
      {
        date: "20/08/2021",
        name: "fridge01",
        mac: "123456789",
        temp: "21",
        humid: "40",
        batt: "100%",
      },
      {
        date: "20/08/2021",
        name: "fridge01",
        mac: "123456789",
        temp: "21",
        humid: "40",
        batt: "100%",
      },
      {
        date: "20/08/2021",
        name: "fridge01",
        mac: "123456789",
        temp: "21",
        humid: "40",
        batt: "100%",
      },
      {
        date: "20/08/2021",
        name: "fridge01",
        mac: "123456789",
        temp: "21",
        humid: "40",
        batt: "100%",
      },
    ],
    newArray1: [],
    newArray2: [],
    chartData: null,
    options: null,
    dateTime: [],
    door1: null,
    door2: null,
    door3: null,
    door4: null,
    install1: null,
    install2: null,
    install3: null,
    install4: null,
    temp1: 0,
    temp2: 0,
    temp3: 0,
    temp4: 0,
    humid1: 0,
    humid2: 0,
    humid3: 0,
    humid4: 0,
    color1: null,
    color2: null,
    color3: null,
    color4: null,
    tempStatus1: false,
    tempStatus2: false,
    tempStatus3: false,
    tempStatus4: false,
    doorStatus1: false,
    doorStatus2: false,
    doorStatus3: false,
    doorStatus4: false,
    nameTemp1: null,
    nameTemp2: null,
    nameTemp3: null,
    nameTemp4: null,
    nameDoor1: null,
    nameDoor2: null,
    nameDoor3: null,
    nameDoor4: null,
    tableTemp: [],
    tableTempDB: [],
    tableTempBF: [],
    dataTpr: [],
    selectTpr: [],
    select: [],
    select1: null,
    chart: false,
    maxValTemp: 0,
    minValTemp: 0,
    sumValTemp: 0,
    avgValTemp: 0,
    maxValHumid: 0,
    minValHumid: 0,
    sumValHumid: 0,
    avgValHumid: 0,
    user: "",
    dataRoom: [],
    dataRoom2: [],
    st1: "",
    lt1: "",
    gw1n: "",
    gw2n: "",
    totalAsset1: 0,
    totalAsset2: 0,
    sta1: "",
    sta2: "",
    staf1: 0,
    staf2: 0,
    getAssetIndoor: [],
    
    
    gateway: [],
    tagfound: [],
    dataTpr: [],
    realData: [],
    actual: 0,
    today: 0,
    total: 0,
    asset: 0,
    totalAsset: 0,
    tpr: 0,
    totalManhour: [],
    dateManhour: [],
    totalManhorExport: [],
    assetfound: [],
    tprAsset: [],
    resultIndoorManHour: [],
    resultIndoorTagManHour: [],
    dataMergeManHour: [],
    show: true,
    alertDate: false,
    targetDatevalue: "",
    targetValue: 0,
    activeLoading:false,

  }),
  methods: {
    getSelect() {
      //  this.$API.get("indoorgateway/AC233FC0BA7A").then((result1) => {
      //       console.log(result1.data[0].sensorfound);
      //        for(var i=0;i<=result1.data[0].sensorfound.length;i++){
      //            let obj = result1.data[0].sensorfound[i];
      this.$API.get("indoorsensor/").then((result) => {
        console.log(result.data);
        for (var i = 0; i <= result.data.length; i++) {
          let obj = result.data[i];
          if (obj.subtype == "S1") {
            let payload = { mac: obj.mac, name: obj.name };
            this.select.push(payload);
            console.log(this.select);
            this.select1 = this.select[0].mac;
            payload = {};
          }
          if (obj.mac == "AC233FAA24B8") {
            this.nameTemp1 = obj.name;
          } else if (obj.mac == "AC233FAA24B5") {
            this.nameTemp2 = obj.name;
          } else if (obj.mac == "AC233FAA24B6") {
            this.nameTemp3 = obj.name;
          } else if (obj.mac == "AC233FAA24B9") {
            this.nameTemp4 = obj.name;
          } else if (obj.mac == "AC233FA9DA04") {
            this.nameDoor1 = obj.name;
          } else if (obj.mac == "AC233FA9DA05") {
            this.nameDoor2 = obj.name;
          } else if (obj.mac == "AC233FA9DA03") {
            this.nameDoor3 = obj.name;
          } else if (obj.mac == "AC233FA9DA06") {
            this.nameDoor4 = obj.name;
          }
        }
        //  if(obj.type=="S1"){
        //     let payload = {mac:obj.mac,name:result2.data[0].name};
        //      this.select1 = result1.data[0].sensorfound[0].mac;
        //     this.selectTpr.push(payload);
        //     payload = {};
        //     console.log(this.select);
        //  }
      });
      //        }
      //     })
    },

    viewSensor(item) {
      console.log(item.mac);
      this.$session.set("sensorname", item.name);
      this.$session.set("macname", item.mac);
      this.$session.set("type", item.type);

      // console.log(this.network,item)
      this.$router.push({
        name: "AssetDashboardIndoor",
        params: {
          sensorname: this.name,
          macname: this.mac,
        },
      });
    },

    generateData() {
      this.chart = false;
      this.sumValHumid = 0;
      this.sumValTemp = 0;
      this.avgValTemp = 0;
      this.avgValHumid = 0;
      this.newArray1 = [];
      this.newArray2 = [];
      this.dateTime = [];
      console.log(this.select1);
      this.$API.get("indoorsensorlog/" + this.select1).then((result) => {
        console.log(result.data);
        for (var i = 0; i < result.data.length; i++) {
          let obj = result.data[i];
          this.newArray1.push(obj.sensordata.temperature);
          this.newArray2.push(obj.sensordata.humidity);
          this.dateTime.push(moment(obj.timestamp).format("LLL"));
          // console.log(this.newArray1);
          // console.log(this.newArray2);
          // console.log(this.dateTime);
        }
        console.log(this.newArray1);
        console.log(this.newArray2);
        console.log(this.dateTime);
        this.maxValTemp = Math.max.apply(Math, this.newArray1);
        this.minValTemp = Math.min.apply(Math, this.newArray1);
        this.maxValHumid = Math.max.apply(Math, this.newArray2);
        this.minValHumid = Math.min.apply(Math, this.newArray2);
        console.log(this.maxValTemp);
        console.log(this.minValTemp);
        console.log(this.maxValHumid);
        console.log(this.minValHumid);
        for (var i = 0; i < this.newArray1.length; i++) {
          this.sumValTemp += this.newArray1[i];
        }
        this.avgValTemp = this.sumValTemp / this.newArray1.length;
        for (var i = 0; i < this.newArray2.length; i++) {
          this.sumValHumid += this.newArray2[i];
        }
        this.avgValHumid = this.sumValHumid / this.newArray2.length;
        console.log(this.avgValTemp.toFixed(2));
        console.log(this.avgValHumid.toFixed(2));
      });

      this.chartData = {
        labels: this.dateTime,
        datasets: [
          {
            label: "Temperature",
            type: "line",
            data: this.newArray1,
            backgroundColor: "rgba(20, 153, 242,.3)",

            borderWidth: 3,
          },
          {
            label: "Humidity",
            type: "line",
            data: this.newArray2,
            backgroundColor: "rgba(247, 15, 15,.2)",
            borderWidth: 3,
          },
        ],
      };
      this.options = {
        responsive: true,
        maintainAspectRatio: false,

        legend: {
          position: "bottom",
        },
        scales: {
          yAxes: [
            {
              id: "A",
              beginAtZero: true,

              position: "left",
              scaleLabel: {
                display: true,
                labelString: "Temoerature (C)",
              },
              ticks: {
                min: -40,
                max: 100,
                beginAtZero: true,
              },
            },
            {
              id: "B",
              beginAtZero: true,
              position: "right",
              scaleLabel: {
                display: true,
                labelString: "Humidity (%)",
              },
              ticks: {
                min: 0,
                max: 100,
                beginAtZero: true,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      };
      setTimeout(() => {
        this.chart = true;
      }, 1000);
    },
    realtimeData() {
      this.sumValHumid = 0;
      this.sumValTemp = 0;
      this.avgValTemp = 0;
      this.avgValHumid = 0;
      // this.chart = false;
      this.$API.get("indoorsensorlog/" + this.select1).then((result) => {
        let obj = result.data[6];

        console.log(result.data[6]);
        this.newArray1.push(obj.sensordata.temperature);
        this.newArray2.push(obj.sensordata.humidity);
        this.dateTime.push(moment(obj.timestamp).format("DD/MM/YY"));

        this.newArray1.splice(0, 1);
        this.newArray2.splice(0, 1);
        this.dateTime.splice(0, 1);
        //  this.newArray1.push(obj.sensordata.temperature);
        // this.newArray2.push(obj.sensordata.humidity);
        //  this.dateTime.push(moment(obj.timestamp).format('LTS'));

        // this.chart = true;
        this.maxValTemp = Math.max.apply(Math, this.newArray1);
        this.minValTemp = Math.min.apply(Math, this.newArray1);
        this.maxValHumid = Math.max.apply(Math, this.newArray2);
        this.minValHumid = Math.min.apply(Math, this.newArray2);
        console.log(this.maxValTemp);
        console.log(this.minValTemp);
        console.log(this.maxValHumid);
        console.log(this.minValHumid);
        for (var i = 0; i < this.newArray1.length; i++) {
          this.sumValTemp += this.newArray1[i];
        }
        this.avgValTemp = this.sumValTemp / this.newArray1.length;
        for (var i = 0; i < this.newArray2.length; i++) {
          this.sumValHumid += this.newArray2[i];
        }
        this.avgValHumid = this.sumValHumid / this.newArray2.length;
        console.log(this.avgValTemp.toFixed(2));
        console.log(this.avgValHumid.toFixed(2));
      });
    },

    getSensorTableBG() {
      this.$API.get("indoorgateway/AC233FC0BA77").then((result) => {
        console.log(result);
        console.log(result.statusText);
        if (result.statusText == "OK") {
          console.log("OKKKKKKKKKKk");
          this.sta1 = "Active";
          this.staf1 = result.data[0].assetfound.length
        }
        console.log(result.data[0].assetfound.length);
        
      });

      this.$API.get("indoorgateway/AC233FC064A9").then((result) => {
        console.log(result);
        // console.log(result.statusText);
        if (result.statusText == "OK") {
          console.log("OKKKKKKKKKKk");
          this.sta2 = "Active";
          this.staf2 = result.data[0].assetfound.length
        }
        
      });


    },

    getSensorTableGW() {
      this.$API.get("indoorgateway").then((result) => {
        console.log(result);
        
        
        
        
      });

      


    },

    getSensorTable() {
      this.dataTpr = [];
      this.tempStatus1 = false;
      this.tempStatus2 = false;
      this.tempStatus3 = false;
      this.tempStatus4 = false;
      this.doorStatus1 = false;
      this.doorStatus2 = false;
      this.doorStatus3 = false;
      this.doorStatus4 = false;
      this.$API.get("indoorgateway/AC233FC0BA7A").then((result1) => {
        console.log(result1.data[0].sensorfound);

        for (var i = 0; i <= result1.data[0].sensorfound.length; i++) {
          let obj = result1.data[0].sensorfound[i];
          this.$API.get("indoorsensor/" + obj.mac).then((result2) => {
            console.log(result2.data);
            if (obj.mac == result2.data[0].mac) {
              if (obj.type == "S1") {
                let payload = {
                  date: moment(obj.timestamp).format("LLL"),
                  mac: obj.mac,
                  name: result2.data[0].name,
                  temp: obj.temperature,
                  humid: obj.humidity,
                  batt: obj.battery,
                };
                this.dataTpr.push(payload);
                payload = {};
              }
              if (result2.data[0].mac == "AC233FAA24B8") {
                console.log(obj.temperature);
                console.log(obj.humidity);
                this.temp1 = obj.temperature;
                this.humid1 = obj.humidity;
                this.tempStatus1 = true;
                // this.nameTemp1 = result2.data[0].name;
              } else if (result2.data[0].mac == "AC233FAA24B5") {
                console.log(obj.temperature);
                console.log(obj.humidity);
                this.temp2 = obj.temperature;
                this.humid2 = obj.humidity;
                this.tempStatus2 = true;
                // this.nameTemp2 = result2.data[0].name;
              } else if (result2.data[0].mac == "AC233FAA24B6") {
                console.log(obj.temperature);
                console.log(obj.humidity);
                this.temp3 = obj.temperature;
                this.humid3 = obj.humidity;
                this.tempStatus3 = true;
                //  this.nameTemp3 = result2.data[0].name;
              } else if (result2.data[0].mac == "AC233FAA24B9") {
                console.log(obj.temperature);
                console.log(obj.humidity);
                this.temp4 = obj.temperature;
                this.humid4 = obj.humidity;
                this.tempStatus4 = true;
                //  this.nameTemp4 = result2.data[0].name;
              }

              //  else{
              //    this.tempStatus1 = false;
              //    this.tempStatus2 = false;
              //    this.tempStatus3 = false;
              //    this.tempStatus4 = false;
              //  }

              if (this.temp1 >= -40 && this.temp1 <= 4) {
                this.color1 = "#3EFF00";
              } else if (this.temp1 > 4 && this.temp1 <= 8) {
                this.color1 = "#FFF000";
              } else if (this.temp1 >= 8) {
                this.color1 = "#FF0000";
              }

              if (this.temp2 >= -40 && this.temp2 <= 4) {
                this.color2 = "#3EFF00";
              } else if (this.temp2 > 4 && this.temp2 <= 8) {
                this.color2 = "#FFF000";
              } else if (this.temp2 >= 8) {
                this.color2 = "#FF0000";
              }

              if (this.temp3 >= -40 && this.temp3 <= -15) {
                this.color3 = "#3EFF00";
              } else if (this.temp3 > -15 && this.temp3 <= -12) {
                this.color3 = "#FFF000";
              } else if (this.temp3 >= -12) {
                this.color3 = "#FF0000";
              }

              if (this.temp4 > -18 && this.temp4 <= -15) {
                this.color4 = "#3EFF00";
              } else if (this.temp4 > -15 && this.temp4 <= -12) {
                this.color4 = "#FFF000";
              } else if (this.temp4 >= -12) {
                this.color4 = "#FF0000";
              }

              if (result2.data[0].mac == "AC233FA9DA04") {
                console.log(!obj.uninstalled);
                console.log(!obj.unlocked);
                this.install1 = !obj.uninstalled;
                this.door1 = !obj.unlocked;
                this.doorStatus1 = true;
                // this.nameDoor1 = result2.data[0].name;
              } else if (result2.data[0].mac == "AC233FA9DA05") {
                console.log(!obj.uninstalled);
                console.log(!obj.unlocked);
                this.install1 = !obj.uninstalled;
                this.door1 = !obj.unlocked;
                this.doorStatus2 = true;
                // this.nameDoor2 = result2.data[0].name;
              } else if (result2.data[0].mac == "AC233FA9DA03") {
                console.log(!obj.uninstalled);
                console.log(!obj.unlocked);
                this.install1 = !obj.uninstalled;
                this.door1 = !obj.unlocked;
                this.doorStatus3 = true;
                // this.nameDoor3 = result2.data[0].name;
              } else if (result2.data[0].mac == "AC233FA9DA06") {
                console.log(!obj.uninstalled);
                console.log(!obj.unlocked);
                this.install1 = !obj.uninstalled;
                this.door1 = !obj.unlocked;
                this.doorStatus4 = true;
                // this.nameDoor4 = result2.data[0].name;
              }
            }
          });
        }
      });
      setTimeout(() => {
        this.tableTemp = this.dataTpr;
        console.log(this.tableTemp);
      }, 300);
    },


     getSensorTableDB() {
      this.dataRoom = []
        
        this.$API.get("indoorgateway/AC233FC0BA77").then((result) => {
          const data = result.data[0].assetfound;
          var currentTime = Date.now()
        currentTime = moment(currentTime)

          data.forEach((element) => {
            this.getAssetIndoor.forEach((element2) => {
              if (element.mac === element2.mac) {
                this.dataRoom.push({
                  name: element2.name,
                  mac: element2.mac,
                  dis: Math.pow(10, (-52 - element.rssi) / (10 * 4)).toFixed(2),
                  rssi: element.rssi,
                });
              }
            });
          });
          var timeDiff = currentTime.diff(moment(result.data[0].lastdate),'m')
          if (
            timeDiff <= 2
          ) {
            this.st1 = "Active";
            // console.log(this.today); h:mm:ss a
          } else {
            this.st1 = "Inactive";
          }
          this.gw1n = result.data[0].name;
          console.log("gw1", result.data[0].assetfound);
          this.lt1 = moment(result.data[0].lastdate).subtract(7, 'hours').format("l h:mm:ss a");
          this.totalAsset1 = result.data[0].assetfound.length;
        });
        
      
      setTimeout(() => {
        this.tableTempDB = this.dataRoom;
        console.log(this.tableTemp);
      }, 300);
    },

    getSensorTableBF() {
      this.dataRoom2 = []
        
        this.$API.get("indoorgateway/AC233FC064A9").then((result) => {
        const data = result.data[0].assetfound;
        console.log("result", result);
        data.forEach((element) => {
          this.getAssetIndoor.forEach((element2) => {
            if (element.mac === element2.mac) {
              this.dataRoom2.push({
                name: element2.name,
                mac: element2.mac,
                dis: Math.pow(10, (-52 - element.rssi) / (10 * 4)).toFixed(2),
                rssi: element.rssi,
              });
            }
          });
        });
        this.totalAsset2 = result.data[0].assetfound.length;
        this.gw2n = result.data[0].name;
      });
        
      
      setTimeout(() => {
        this.tableTempBF = this.dataRoom2;
        console.log(this.tableTempBF);
      }, 300);
    },
  },

  mounted() {
     let admin = this.$session.get("admin")
    switch (this.user || admin) {
      case "betagrodemo":
        console.log("betagrodemo");
        var elem = document.getElementsByClassName("con-vs-card");
        Array.prototype.filter.call(elem, function (testElement) {
          testElement.style.background = "#121212";
        });
        break;
      default:
        console.log("Try looking up for a hint.");
    }
  },
  created() {
    this.user = this.$session.get("username");

    console.log(this.user);
    // this.getSensor()
    this.getSensorTable();
    this.getSensorTableBG();
    
    // this.getTempParnel()
    // this.getDoorParnel()
    // this.tempSensor()
    // this. doorSensor()
    this.getSelect();
    this.generateData();
    //  this.realtimeData()
    // this.statusDevice()
    // this.statusDevice()
    // setInterval(() => {
      // this.generateData()
      //  this.doorSensor()
      // this.tempSensor()
      // this.statusDevice()
      // this.statusDevice()
      this.getSensorTable();
      this.getSensorTableDB();

      this.$API.get("indoorgateway").then((result) => {
        console.log(result.data);
        
        
        
        
      });

      this.getSensorTableBF();
      this.getSensorTableGW();
      //  this.getSelect()
      // this.realtimeData()
      // this.getSelect()
      //  this.generateData()
      this.realtimeData();




      this.$API.get("indoorasset").then((result) => {
        // console.log("indoor result",result.data)
        this.getAssetIndoor = result.data;
      });

      

      

      
    

    
  },
};
</script>
<style scoped>
.fontBetagro {
  color: #32c040;
  font-size: 15px;
}
img {
  max-width: 100%;
  max-height: 100%;
}
.fontColorHeaderAVG{
  color: #ffffff;
  font-weight: 500;
  font-size: 1rem;
  white-space: nowrap;
}
</style>